import { Component } from '@angular/core';
import { AppService } from '../app.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-payments',
  standalone: false,
  templateUrl: './payments.component.html',
  styleUrl: './payments.component.css'
})
export class PaymentsComponent {

    constructor(
      public appService: AppService, private router: Router,
    ) {}

    upgrade(){
      this.router.navigate(['/subscription']); 
    }

    async topUP(md:any): Promise<void> {
        let httpOptions = {
          headers: {
            "Content-Type": "application/json",
          },
        };
        try {
          const startTime = performance.now();
          let obj = {
            mode:md
          }
          const res = await this.appService.postRequest(obj, "StripeService/CreateCheckoutSession");    
          if (res.URL) {
            window.location.href = res.URL;
          }
        } catch (err) {
          console.error("Failed to fetch Stripe Payment Page URL:", err);
        }
      }

}
